import React from 'react';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import Typography from '@material-ui/core/Typography';
import Cookies from 'universal-cookie';
// import TagManager from 'react-gtm-module';

export default () => {
    const cookies = new Cookies();
    const color = cookies.get('System-Color');

    const [cor, setCor] = React.useState((color==null)?'light':color);

    const handleChange = (event) => {
        // TagManager.dataLayer({
        //     dataLayer: {
        //       event: 'event',
        //       eventCategory: 'tokstok:fornecedores:temas',
        //       eventAction: 'clique:opcao',
        //       eventLabel: `tema:${event.target.value}`,
        //     }
        // });

        setCor(event.target.value);
        cookies.set('System-Color',event.target.value);
        document.location.reload();
    };

    return (
        <>
            <Typography variant="h6" gutterBottom>
                Temas
            </Typography>
            <FormControl component="fieldset">
                <RadioGroup aria-label="cor" name="cor" value={cor} onChange={handleChange}>
                    <FormControlLabel value="light" control={<Radio />} label="LightMode" />
                    <FormControlLabel value="dark" control={<Radio />} label="DarkMode" />
                </RadioGroup>
            </FormControl>
        </>
    );
};